    <div class="calendars mtop2">
    <div class="dib col-md-6">
        <mat-form-field>
            <mat-label>{{'OTHERS.PERIOD' | translate}}</mat-label>
            <mat-select [formControl]="periodControl" (selectionChange)="selectionChangePeriodValue($event)">
                <mat-option *ngFor="let period of periodCombo" [value]="period.value">
                    {{period.viewValue | translate}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="dib col-md-6" *ngIf="periodControl.value === 'Hour'">
        <mat-form-field>
            <mat-label>{{'TIMEZONE.HOUR' | translate}}</mat-label>
            <mat-select [formControl]="hourControl" (selectionChange)="selectionChangeTimeRangeValue($event)">
                <mat-option  *ngFor="let hour of hourCombo" [value]="hour.value">
                    {{hour.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="dib col-md-6" *ngIf="periodControl.value === 'Day'">
        <mat-form-field>
            <mat-label>{{'TIMEZONE.DAY' | translate}}</mat-label>
            <mat-select [formControl]="dayControl" (selectionChange)="selectionChangeTimeRangeValue($event)">
                <mat-option *ngFor="let day of dayCombo" [value]="day.value">
                    {{day.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="dib col-md-6" *ngIf="periodControl.value === 'Week'">
        <mat-form-field>
            <mat-label>{{'TIMEZONE.WEEK' | translate}}</mat-label>
            <mat-select [formControl]="weekControl" (selectionChange)="selectionChangeTimeRangeValue($event)">
                <mat-option *ngFor="let week of weekCombo" [value]="week.value">
                    {{week.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="dib col-md-6" *ngIf="periodControl.value === 'Month'">
        <mat-form-field>
            <mat-label>{{'TIMEZONE.MONTH' | translate}}</mat-label>
            <mat-select [formControl]="monthControl" (selectionChange)="selectionChangeTimeRangeValue($event)">
                <mat-option *ngFor="let month of monthCombo" [value]="month.value">
                    {{month.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>